import React, { useCallback } from "react";
import { useMappedState, useDispatch } from "redux-react-hook";
import { Field, reduxForm } from "redux-form";
import { NavLink } from "reactstrap";
import { Translate } from "react-localize-redux";
import { loginAction } from "../../../redux/actions/auth.actions";
import { renderErrorsList } from "../../../utils/formUtils";
import InputField from "../../../components/forms/InputField";
import "./styles.scss";
import FaceBookAuthButton from "../../FaceBookAuthButton";

const LoginForm = props => {
  const dispatch = useDispatch();
  const login = useCallback(credentials => dispatch(loginAction(credentials)));

  const { handleSubmit } = props;
  const getAuth = useCallback(({ auth }) => auth);
  const auth = useMappedState(getAuth);

  const handleOnLogin = values => {
    const { username, password } = values;
    login({ username, password });
  };

  return (
    <div className="col-lg-3 col-md-4 col-sm-6 col-6 text-center">
      <NavLink href="/">
        <h3 id="sign-in-brand">myHelloHello</h3>
      </NavLink>
      <br />
      <form onSubmit={handleSubmit(handleOnLogin)}>
        <Field
          label="username"
          name="username"
          placeholder="Username"
          type="text"
          id="username-input"
          hideLabel={true}
          textAlign="center"
          component={InputField}
        />
        <Field
          label="Password"
          name="password"
          placeholder="Password"
          type="password"
          id="password-input"
          hideLabel={true}
          textAlign="center"
          component={InputField}
        />
        <br />
        <button type="submit" id="login-btn" className="btn btn-primary">
          <Translate id="signInText" />
        </button>
      </form>

      <br />
      <ul className="list-group">{renderErrorsList(auth.errors)}</ul>

      {/*<div className="strike">*/}
      {/*  <span>*/}
      {/*    <i>or</i>*/}
      {/*  </span>*/}
      {/*</div>*/}
      {/*<br />*/}

      {/*<FaceBookAuthButton />*/}

      <br />
      <p className="text-center">
        <NavLink href="/recover-account" className="sign-out-btn">
          <Translate id="forgotSignIn" />
        </NavLink>
      </p>
      <p className="text-center">
        <Translate id="notInTheDirectory" />
        <NavLink href="/register" className="sign-out-btn">
          <Translate id="Joinhere" />
        </NavLink>
      </p>
    </div>
  );
};

function validate(values) {
  // will be called before the form is submitted
  const errors = {};

  // validate the input data
  if (!values.username) {
    errors.username = "Enter a username";
  }
  if (!values.password) {
    errors.password = "Enter a password";
  }

  return errors;
}

const connectedReduxForm = reduxForm({
  validate,
  form: "LoginForm"
})(LoginForm);

export default connectedReduxForm;



// WEBPACK FOOTER //
// ./src/components/forms/LoginForm/LoginForm.jsx